import { PaymentModule } from '@sm-dashboard/types';

/** Shown on the donations screen for a world shaliach who has no paid module. Not a purchasable plan. */
export const worldDonationsPaymentGate: PaymentModule = {
  tag: 'תרומות',
  name: 'תרומות',
  description: 'מעקב אחרי תרומות וזיכויים',
  price: '',
  features: [],
  routes: ['/desk/donations'],
  variant: 'primary'
};

const withDonations = (routes: string[]) => ['/desk/donations', ...routes];

export const WORLD_PAYMENT_MODULES: PaymentModule[] = [
  {
    tag: 'CRM',
    name: 'אנשים (CRM)',
    description: 'CRM עבור שלוחים חו״ל',
    price: '200 ₪',
    features: [
      'ניהול אנשי קשר',
      'קבוצות ותגיות',
      'דיוור בווטסאפ, מייל וסמס',
      'תבניות מוכנות ומעוצבות לשליחה במייל',
      'עורך AI חכם לניסוח הודעות',
      'מודול טפסים ושאלונים',
      'דו"ח לרבי',
      'לוח בקרה חכם',
      'תזכורות וניהול משימות',
      'רשימת ימי הולדת שבועית לווטסאפ'
    ],
    routes: withDonations(['/crm', '/crm/forms/user-forms']),
    variant: 'primary',
    myopId: 'button-subscribe-crm',
    planId: '761fc1d9-5ad3-44a0-bae6-e9a3db8086ed'
  },
  {
    tag: 'קדמה עיצובים',
    name: 'קדמה',
    description: 'קדמה עבור שלוחים חו״ל',
    price: '180 ₪',
    features: [
      'מנוי קנבה פרו',
      '2000+ עיצובים לשימוש חופשי ללא הגבלה',
      'מאגר מתעדכן כל הזמן',
      'סרטונים להתאמה אישית',
      'עיצובים למסכים',
      'עיצובים לשלטים',
      'עיצובים לרולאפים'
    ],
    routes: withDonations(['no-route']),
    variant: 'secondary',
    myopId: 'button-subscribe-kedma',
    planId: '46c73755-bab7-4bf0-a5b7-1e4eacb37f99'
  },
  {
    tag: 'קדמה דפים אישיים',
    name: 'דפים אישיים',
    description: 'קדמה דפים אישיים שלוחים חו״ל',
    price: '180 ₪',
    features: [
      'דפי אירועים',
      'דפי קמפיינים',
      'נתוני קמפיין בזמן אמת',
      'יעדים ויחידות תרומה',
      'סליקה אישית',
      'עיצוב דפים בהתאמה אישית',
      'ספריית דפים מעוצבים',
      'טפסי הרשמה',
      'מכירת כרטיסים'
    ],
    routes: withDonations([
      '/outreach/personal-pages',
      '/org/event-sales',
      '/desk/registerations',
      '/outreach/campaign-creation',
      '/outreach/event-creation',
      '/outreach/information-page-creation',
      '/outreach/registration-creation',
      '/campaigns'
    ]),
    variant: 'primary',
    myopId: 'button-subscribe-private-page',
    planId: 'ded519ba-8b79-4848-967b-1a28d8e509c3'
  },
  {
    tag: 'אתר אישי',
    name: 'אתר אישי',
    description: 'אתר אישי עבור שלוחים חו״ל x Nanosite',
    price: '100 ₪',
    features: [
      'אתר אישי מעוצב',
      'ניהול תוכן ועמודים',
      'חיבור ל-Nanosite',
      'התאמה אישית למותג'
    ],
    routes: withDonations(['no-route']),
    variant: 'primary',
    myopId: 'button-subscribe-private-site',
    planId: 'c4e4e6b4-b661-4d73-a182-a46a0855cc06'
  },
  {
    tag: 'סעודות שבת',
    name: 'סעודות שבת',
    description: 'סעודות שבת עבור שלוחים חו״ל',
    price: '200 ₪',
    features: [
      'מכירת כרטיסים לסעודות שבת',
      'ניהול סדרות סעודות שבועיות',
      'דפי הרשמה לאירועים',
      'מעקב הרשמות ותשלומים'
    ],
    routes: withDonations(['no-route']),
    variant: 'primary',
    myopId: 'button-subscribe-shabbat',
    planId: '0d5345c6-23bb-44d8-b609-cf0dc3fb3df8'
  },
  {
    tag: 'קהילה חו״ל',
    name: 'קהילה חו״ל',
    description: 'הכל כלול אתר אישי, קדמה, סעודות שבת, crm, דפים אישיים',
    price: '700 ₪',
    features: [
      'כל הפיצרים של אנשים (CRM)',
      'כל הפיצרים של קדמה עיצובים',
      'כל הפיצרים של דפים אישיים',
      'כל הפיצרים של אתר אישי',
      'כל הפיצרים של סעודות שבת',
      'גישה מלאה לכל המודולים',
      'תמיכה מועדפת'
    ],
    routes: withDonations([
      '/crm',
      '/crm/forms/user-forms',
      '/outreach/personal-pages',
      '/org/event-sales',
      '/desk/registerations',
      '/outreach/campaign-creation',
      '/outreach/event-creation',
      '/outreach/information-page-creation',
      '/outreach/registration-creation',
      '/campaigns'
    ]),
    variant: 'primary',
    myopId: 'button-subscribe-full',
    planId: '39cc0858-f83b-4487-b8cb-7cb6af3e279c'
  }
];
